<section id="contact-section" class=" py-36 px-4">
  <div class="container relative text-gray-800">
    <h2 class="text-3xl font-extrabold mb-20 text-center capitalize">
      Restons <span class="text-blue-800"> en contact</span>
    </h2>
    <div
      class="grid lg:grid-cols-3 md:grid-cols-1 gap-1 justify-items-stretch lg:px-20 px-0"
    >
      <div class="pl-8 pr-4 lg:col-span-2 col-span-1">
        <form
          class="space-y-4 text-gray-900"
          action="mailto:hugo.suissia@gmail.com"
          method="post"
          enctype="text/plain"
        >
          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
            <div class="w-full px-2 md:w-1/2">
              <label class="block mb-1" for="formGridCode_name">Nom</label>
              <input
                class="w-full h-10 px-3 text-base placeholder-gray-600 border rounded-lg focus:shadow-outline"
                type="text"
                name="nom"
                id="form_nom"
              />
            </div>
            <div class="w-full px-2 md:w-1/2">
              <label class="block mb-1" for="formGridCode_last">Prenom</label>
              <input
                class="w-full h-10 px-3 text-base placeholder-gray-600 border rounded-lg focus:shadow-outline"
                type="text"
                name="prenom"
                id="form_prenom"
              />
            </div>
          </div>
          <div class="flex flex-wrap">
            <div class="w-full">
              <label class="block mb-1" for="formGridCode_card">Sujet</label>
              <input
                class="w-full h-10 px-3 text-base placeholder-gray-600 border rounded-lg focus:shadow-outline"
                type="text"
                name="sujet"
                id="form_sujet"
              />
            </div>
          </div>
          <div class="flex flex-wrap">
            <div class="w-full">
              <label class="block mb-1" for="formGridCode_card">Message</label>
              <textarea
                class="w-full h-40 px-3 text-base placeholder-gray-600 border rounded-lg focus:shadow-outline"
                rows="5"
                type="text"
                name="message"
                id="form_message"
              />
            </div>
          </div>
          <button
            class="h-10 px-5 text-white transition-colors duration-150 bg-blue-800 rounded-lg focus:shadow-outline hover:bg-blue-900"
            >Envoyer</button
          >
        </form>
      </div>
      <div class="pl-4 pr-8 border-l border-gray-900">
        <h3 class="text-xl font-bold text-gray-800 mb-4">Informations :</h3>
        <ul>
          <li class="mb-4">
            <div>
              <img
                class="w-8 h-8 inline-block"
                src="./images/user.png"
                alt="user icon"
                width="16"
                height="16"
              />
              <p class="inline-block">Suissia Hugo</p>
            </div>
          </li>
          <li class="mb-4">
            <div>
              <img
                class="w-8 h-8 inline-block"
                src="./images/email.png"
                alt="email icon"
                width="16"
                height="16"
              />
              <p class="inline-block">hugo.suissia@gmail.com</p>
            </div>
          </li>
          <li class="mb-4">
            <div>
              <img
                class="w-8 h-8 inline-block"
                src="./images/linkedin.png"
                alt="linkedin icon"
                width="16"
                height="16"
              />
              <a
                class="inline-block text-blue-500 underline"
                href="https://www.linkedin.com/in/hugo-suissia-47653414b/"
                target="_blank"
              >
                LinkedIn</a
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
